import { PromptRequest, PromptTypeKey } from "../../../types/promptTypes";
import FieldContainer from "./FieldContainer";
import InputField from "../../dynamic/InputField";
import { usePromptStore } from "../../../store/promptStore";
import TwoFactorAuthField from "./TwoFactorAuthField";

type NumberCodeFieldProps = {
  index: number;
  onEnter?: () => void;
};

const NumberCodeField = (props: NumberCodeFieldProps) => {
  const { index, onEnter } = props;
  const prompts = usePromptStore((state) => state.prompts);
  const field = prompts[index] as PromptRequest<PromptTypeKey.NUMBER_CODE>;
  const setPromptValue = usePromptStore((state) => state.setPromptValue);
  const promptValue = usePromptStore((state) => state.promptValues[index]);

  return (
    <div>
      <FieldContainer
        field={field}
        renderLabel={field?.attributes?.length ? false : true}
      >
        {field?.attributes?.length ? (
          <TwoFactorAuthField
            length={field.attributes.length}
            value={promptValue}
            onChange={(value) => setPromptValue(index, value)}
            label={field.label}
            onEnter={onEnter}
          />
        ) : (
          <InputField
            label={field.label}
            value={promptValue}
            type="number"
            onChange={(value) => setPromptValue(index, value)}
            onEnter={onEnter}
            autoFocus={index === 0}
          />
        )}
      </FieldContainer>
    </div>
  );
};

export default NumberCodeField;
